module.exports = __webpack_public_path__ + "static/shameless-charlatan-25cc6876e2df9ed5b876b2a31fa1e02d.webp";